<template>
    <div class="row">
   <div class="col-md-12 mb-5 mt-3">
        <h1 class="m-0 text-center error-status">404</h1>
        <h4 class="text-center m-0">Halaman Tidak Ditemukan</h4>
        <p class="text-center">Maaf, halaman yang anda maksud tidak terdaftar!</p>
        <p class="text-center"><a href="/" role="button" aria-pressed="true" class="link-call">Kembali ke Halaman Utama</a></p>
   </div>
</div>
</template>

<script>
export default {
    name: 'NotFound',
};
</script>